<div [hidden]="bulkUpdateInProgress" class="ws-flex-container-vertical ws-flex-auto">
    <div class="entity-header">
        <ol class="breadcrumb float-start">
            <li class="breadcrumb-item">
                @if (parentCompany) {
                    <a class="pointer" (click)="goToParentCompany()">{{ parentCompany.name }}</a>
                }
            </li>
        </ol>
        <div class="clearfix"></div>
    </div>
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title">Forecasting and Budgeting</h4>
            <div class="ws-section__header__actions">
                <div class="ws-section__header__actions__item">
                    <label style="margin-bottom: 0; margin-right: 10px;">Mode:</label>
                    <label class="radio-inline">
                        <input type="radio"
                               [(ngModel)]="forecastingBudgetingService.selectedMode"
                               (change)="modeChanged()"
                               value="forecast"
                               [disabled]="!budgetsEnabled">
                        Forecast
                    </label>
                    <label class="radio-inline">
                        <input type="radio"
                               [(ngModel)]="forecastingBudgetingService.selectedMode"
                               (change)="modeChanged()"
                               value="budget"
                               [disabled]="!budgetsEnabled">
                        Budget
                    </label>
                </div>
                <div class="ws-section__header__actions__item">
                    @if (hasEditPermission && !forecastingBudgetingService.editMode) {
                        <button type="button"
                                class="ace-btn btn-sm btn-primary has-icon"
                                (click)="toggleEditMode(true)"
                                title="Edit Mode">
                            <i class="fa fa-pencil"></i>
                        </button>
                    }
                    @if (forecastingBudgetingService.editMode) {
                        <button type="button"
                                class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                (click)="toggleEditMode(false)"
                                title="Exit Edit Mode"
                                [disabled]="forecastingBudgetingService.isEditingCell">
                            <i class="fa fa-close"></i>
                        </button>
                    }
                    <button type="button"
                            class="ace-btn btn-sm btn-primary has-icon"
                            (click)="refresh()"
                            title="Refresh"
                            [disabled]="forecastingBudgetingService.selectedMode === 'budget' && !selectedBudget">
                        <i class="fa fa-refresh"></i>
                    </button>
                    @if (!isMaximized) {
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary has-icon"
                                (click)="toggleMaximize(true)">
                            <i class="fa fa-arrows-alt" title="Expand"></i>
                        </button>
                    }
                    @if (isMaximized) {
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary has-icon"
                                (click)="toggleMaximize(false)">
                            <i class="fa fa-compress" title="Collapse"></i>
                        </button>
                    }
                </div>
            </div>
        </div>
        @if (availableFilters && filters) {
            <div
                class="ws-section__filters d-flex justify-content-between align-items-baseline flex-grow-1"
                [class.remove-panel]="isMaximized">
                <div class="d-flex justify-content-between align-items-baseline flex-grow-1 flex-wrap">
                    @if (forecastingBudgetingService.selectedMode === 'forecast') {
                        @if (filters) {
                            <div>
                                <label>Tax Year:</label>
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="filters.yearEnd"
                                        style="width: auto; display: inline-block; margin-left: 5px;"
                                        (change)="taxYearsChanged()">
                                    @for (year of taxYears; track year) {
                                        <option [ngValue]="year">{{ year }}</option>
                                    }
                                </select>
                            </div>
                        }
                    }
                    @if (forecastingBudgetingService.selectedMode === 'budget') {
                        <div class="d-flex flex-grow-1 align-items-baseline">
                            <div class="me-4">
                                <label>Budget:</label>
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="selectedBudget"
                                        style="width: auto; display: inline-block; margin-left: 5px;"
                                        (change)="selectedBudgetChanged()">
                                    <option disabled [ngValue]="undefined">--- select ---</option>
                                    @for (budget of availableBudgets; track budget) {
                                        <option [ngValue]="budget">{{ budget.budgetName }}</option>
                                    }
                                </select>
                            </div>
                            @if (selectedBudget) {
                                <div class="me-4">
                                    <label>Basis:</label>
                                    <select class="form-select form-select-sm"
                                            [(ngModel)]="selectedBudget.budgetBasis"
                                            style="width: auto; display: inline-block; margin-left: 5px;"
                                            (change)="selectedBudgetBasisChanged()"
                                            [disabled]="!forecastingBudgetingService.editMode || selectedBudget.isFrozen || savingBudget">
                                        <option [ngValue]="CompanyBudgetBasisEnum.Accrual">Accrual</option>
                                        <option [ngValue]="CompanyBudgetBasisEnum.Cash">Cash</option>
                                        <option [ngValue]="CompanyBudgetBasisEnum.AccrualAndCash">Accrual and Cash
                                        </option>
                                    </select>
                                </div>
                            }
                            @if (selectedBudget) {
                                <div class="me-4">
                                    <label>Fiscal Period:</label>
                                    <p style="width: auto; display: inline-block; margin-left: 5px;">
                                        {{ selectedBudget.fiscalPeriodBegin | date:'MM/dd/yyyy':'utc' }}
                                        - {{ selectedBudget.fiscalPeriodEnd | date:'MM/dd/yyyy':'utc' }}
                                    </p>
                                </div>
                            }
                            @if (selectedBudget) {
                                <div class="d-flex me-2"
                                     [style.align-items]="forecastingBudgetingService.editMode ? 'center' : 'initial'">
                                    <label style="margin-right: 5px;">Date:</label>
                                    <weissman-datetime [readOnly]="!forecastingBudgetingService.editMode"
                                                       [(inputDate)]="selectedBudget.budgetDate"
                                                       [dateOnly]="true"
                                                       (change)="showBudgetApplyButton = true"
                                                       [isDisabled]="savingBudget">
                                    </weissman-datetime>
                                </div>
                            }
                            @if (showBudgetApplyButton) {
                                <button
                                    class="ace-btn btn-sm btn-primary"
                                    (click)="saveCompanyBudget()">
                                    Apply
                                </button>
                            }
                        </div>
                        @if (forecastingBudgetingService.editMode) {
                            @if (selectedBudget && !selectedBudget.isFrozen) {
                                <button
                                    class="ace-btn has-icon btn-primary btn-danger mb-0"
                                    (click)="deleteBudget()"
                                    [disabled]="savingBudget">
                                    <i class="fa fa-trash"></i>
                                </button>
                            }
                            <button class="ace-btn btn-sm btn-primary my-0"
                                    [hidden]="!isTLCompany"
                                    (click)="addNewBudget()">
                                New Budget
                            </button>
                            @if (selectedBudget) {
                                <button
                                    [disabled]="!isFreezeUnfreezeAllowed() || savingBudget"
                                    class="ace-btn btn-primary btn-sm my-0"
                                    (click)="freezeUnfreezeBudget()">
                                    {{ freezeButtonLabel }}
                                </button>
                            }
                        }
                        @if (selectedBudget && selectedBudget.isFrozen) {
                            <div>
                                <span style="color:var(--ace-info); font-size:18px; font-weight:bold;">FROZEN</span>
                            </div>
                        }
                    }
                    <div [class.invisible]="!showFilterApplyButton" class="mt-3 me-3">
                        <button class="ace-btn btn-primary btn-sm" (click)="applyFilters()">Apply</button>
                    </div>
                </div>
            </div>
        }
        @if (availableFilters && filters) {
            <div class="ws-section__filters" style="align-items: baseline;" [class.remove-panel]="isMaximized">
                @if (availableFilters.companies.length) {
                    <div class="ws-section__filters__filter-group" style="padding-top:30px;">
                        <div class="ws-flex-container-horizontal ws-flex-auto" style="align-items: baseline;">
                            <label class="ws-flex-none">Companies:</label>
                            <select multiple class="filter-select" (change)="companiesSelected($event.target)">
                                @for (company of availableFilters.companies; track company) {
                                    <option
                                        [value]="company.id"
                                        [selected]="filters.companyIds.includes(company.id)"
                                        [style.font-weight]="company.id === forecastingBudgetingService.tlCompany.companyID ? 'bold': 'normal'">
                                        {{ company.name }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                }
                @if (availableFilters.states.length) {
                    <div class="ws-section__filters__filter-group" style="padding-top:30px;">
                        <div class="ws-flex-container-horizontal ws-flex-auto" style="align-items: baseline;">
                            <label class="ws-flex-none">States:</label>
                            <select multiple
                                    class="filter-select"
                                    (change)="statesSelected($event.target)"
                                    style="min-width: 60px; width: 60px;">
                                @for (state of availableFilters.states; track state) {
                                    <option [value]="state.id"
                                            [selected]="filters.stateIds.includes(state.id)">{{ state.name }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                }
                @if (availableFilters.propertyTypes.length) {
                    <div class="ws-section__filters__filter-group" style="padding-top:30px;">
                        <div class="ws-flex-container-horizontal ws-flex-auto" style="align-items: baseline;">
                            <label class="ws-flex-none">Property types:</label>
                            <select multiple
                                    class="filter-select"
                                    (change)="propertyTypesSelected($event.target)"
                                    style="min-width: 150px; width: 150px;">
                                @for (propertyType of availableFilters.propertyTypes; track propertyType) {
                                    <option [value]="propertyType.id"
                                            [selected]="filters.propertyTypeIds.includes(propertyType.id)">{{ propertyType.name }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                }
                @if (availableFilters.activityStatuses.length) {
                    <div class="ws-section__filters__filter-group" style="padding-top:30px;">
                        <div class="ws-flex-container-horizontal ws-flex-auto" style="align-items: baseline;">
                            <label class="ws-flex-none">Activity Statuses:</label>
                            <select multiple
                                    class="filter-select"
                                    (change)="activityStatusesSelected($event.target)"
                                    style="min-width: 150px; width: 150px;">
                                @for (activityStatus of availableFilters.activityStatuses; track activityStatus) {
                                    <option [value]="activityStatus.id"
                                            [selected]="filters.activityStatusIds.includes(activityStatus.id)">{{ activityStatus.name }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                }
                <div class="ws-section__filters__filter-group" style="padding-top:30px;">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" [(ngModel)]="filters.siteRollup" (change)="filterChanged()">
                            Summarize by Sites
                        </label>
                    </div>
                </div>
                <div class="ws-section__filters__filter-group" style="align-items: baseline; padding-top: 30px;">
                    @if (forecastGridSearchModel) {
                        <div class="filter-dropdowns">
                            <div class="ws-flex-container-horizontal ws-flex-auto ws-flex-align-items-center">
                                <label class="ws-flex-none">Show YoY changes for:</label>
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="forecastGridSearchModel.showYoYChangesFor"
                                        (change)="filterChanged()">
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.None">None</option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.AssessmentsAndTaxes">Assessments and
                                        Taxes
                                    </option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.Assessments">Assessments</option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.Taxes">Taxes</option>
                                </select>
                            </div>
                            <div class="ws-flex-container-horizontal ws-flex-auto ws-flex-align-items-center">
                                <label class="ws-flex-none">Show additional years:</label>
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="priorYears"
                                        (change)="taxYearsChanged()">
                                    @for (option of priorOptions; track option) {
                                        <option [ngValue]="option">{{ option }}</option>
                                    }
                                </select>
                            </div>
                            <div class="ws-flex-container-horizontal ws-flex-auto ws-flex-align-items-center">
                                <label class="ws-flex-none">Alternate Assessments:</label>
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="forecastGridSearchModel.alternateAssessmentView"
                                        (change)="filterChanged()">
                                    <option [ngValue]="ForecastBudgetAltAssessmentView.Hide">Hide</option>
                                    <option [ngValue]="ForecastBudgetAltAssessmentView.Show">Show</option>
                                    <option [ngValue]="ForecastBudgetAltAssessmentView.ShowOnlyAlternates">Show Only
                                        Alternates
                                    </option>
                                </select>
                            </div>
                            <div class="ws-flex-container-horizontal ws-flex-auto"
                                 style="align-items: baseline;"
                                 [class.invisible]="forecastGridSearchModel.mode !== ForecastBudgetScreenModeEnum.TaxYearBudget">
                                <label class="ws-flex-none">Show budget entries for:</label>
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="forecastGridSearchModel.showBudgetEntriesFor"
                                        (change)="filterChanged()">
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.None">None</option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.AssessmentsAndTaxes">Assessments and
                                        Taxes
                                    </option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.Assessments">Assessments</option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.Taxes">Taxes</option>
                                </select>
                            </div>
                            <div class="ws-flex-container-horizontal ws-flex-auto"
                                 style="align-items: baseline;"
                                 [class.invisible]="forecastGridSearchModel.mode === ForecastBudgetScreenModeEnum.Forecast">
                                <label class="ws-flex-none">Show budget variances:</label>
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="forecastGridSearchModel.showBudgetVariances"
                                        (change)="filterChanged()">
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.None">None</option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.AssessmentsAndTaxes">Assessments and
                                        Taxes
                                    </option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.Assessments">Assessments</option>
                                    <option [ngValue]="ShowAssessmentsTaxesEnum.Taxes">Taxes</option>
                                </select>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
    <div class="ws-flex-container-horizontal ws-stretch ws-overflow-auto">
        <ws-ag-grid-angular gridClass="forecasting-budgeting-grid"
                            rowSelection="multiple"
                            [gridId]="'C6CF13D2-702B-49BA-970D-1375127218C9'"
                            [gridOptions]="gridOptions"
                            [exportOptions]="exportOptions"
                            [isBulkUpdateVisible$]="isBulkUpdateVisible$"
                            (gridReady)="onAgGridReady($event)"
                            (selectionChanged)="onSelectionChanged($event)"
                            (bulkUpdate)="bulkUpdate()">
        </ws-ag-grid-angular>
    </div>
    @if (forecastGridSearchModel) {
        <div
            class="ws-flex-container-horizontal ws-overflow-auto"
            style="align-items: center;"
            [style.min-height]="forecastGridSearchModel.mode === ForecastBudgetScreenModeEnum.Forecast ? '125px': '140px'"
            [class.remove-panel]="isMaximized">
            <div style="display: flex; justify-content: space-around; width: 100%;">
                <div style="width: 430px;">
                    @if (forecastingBudgetingService.editMode && forecastGridSearchModel.mode === ForecastBudgetScreenModeEnum.TaxYearBudget) {
                        <div
                            class="checkbox"
                            style="margin-top: 0;"
                            [class.disabled]="selectedBudget && selectedBudget.isFrozen"
                            [class.remove-panel]="isMaximized">
                            <label>
                                <input type="checkbox"
                                       [(ngModel)]="forecastingBudgetingService.autoSyncBudgetToLatest"
                                       [disabled]="selectedBudget && selectedBudget.isFrozen">
                                Automatically sync assessment and tax change to non-frozen budget
                            </label>
                        </div>
                    }
                    @if (forecastingBudgetingService.selectedMode === 'forecast') {
                        <div>
                            <forecast-create-missing [numMissingTaxYears]="missingSyncData.numMissingTaxYears"
                                                     [lrUpdateInProgress]="lrUpdateInProgress"
                                                     [taxYear]="filters.yearEnd"
                                                     [editMode]="forecastingBudgetingService.editMode"
                                                     (createClick)="createMissingForecast()">
                            </forecast-create-missing>
                        </div>
                    }
                    @if (forecastingBudgetingService.selectedMode === 'budget' && forecastingBudgetingService.selectedView === 'taxYear' && selectedBudget) {
                        <div>
                            <budget-taxyear-create-missing [missingSyncData]="missingSyncData"
                                                           [lrUpdateInProgress]="lrUpdateInProgress"
                                                           [taxYear]="filters.yearEnd"
                                                           [editMode]="forecastingBudgetingService.editMode"
                                                           [isBudgetFrozen]="selectedBudget.isFrozen"
                                                           (createClick)="createMissingBudgetTaxYear()">
                            </budget-taxyear-create-missing>
                            <div style="margin-top: 5px;">
                                <budget-taxyear-sync-budgets [missingSyncData]="missingSyncData"
                                                             [lrUpdateInProgress]="lrUpdateInProgress"
                                                             [editMode]="forecastingBudgetingService.editMode"
                                                             [isBudgetFrozen]="selectedBudget.isFrozen"
                                                             (syncClick)="syncBudgets()">
                                </budget-taxyear-sync-budgets>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</div>
<forecasting-budgeting-bulk-updating [(bulkUpdateInProgress)]="bulkUpdateInProgress"
                                    [(bulkUpdateCanceled)]="bulkUpdateCanceled"
                                    [bulkUpdateProgress]="bulkUpdateProgress"
                                    [bulkUpdateEntityType]="bulkUpdateEntityType"
                                    (refresh)="refresh()"
                                    [getCurrentBulkUpdateSelection]="getCurrentBulkUpdateSelection">
</forecasting-budgeting-bulk-updating>
